import $ from "jquery";
import Matrix from "./matrix";
import util from "../util";
import store from "../store";

export function removeSnapGuides() {
  $('.page-snap-guide').remove();
  $('.snap-guide').remove();
  $('.move').removeClass('guided');
}
export function removeResizeSnapGuides() {
  $('.resize-snap-guide').remove();
  $('.page-snap-guide').remove();
}

function addSnapGuide($target, position, elClassName) {
  $target.append(`<div class="${elClassName} ${position}"></div>`);
}

function addPageSnapGuide($page, position) {
  $page.append(`<div class="page-snap-guide ${position}"></div>`);
}

export function showSnapGuides($target, top, left) {
  let width = parseFloat($target.attr('data-width') || 0);
  let height = parseFloat($target.attr('data-height') || 0);

  if (width === 0) {
    width = $target.width();
    height = $target.height();
    $target.attr('data-width', width);
    $target.attr('data-height', height);
  }

  const right = left + width;
  const bottom = top + height;
  const hmid = left + (width / 2);
  const vmid = top + (height / 2);

  const buffer = 1;
  const pageBuffer = 3;
  let candidates = [];

  let i; const { length } = Matrix.getElements();
  for (i = 0; i < length; i++) {
    const element = Matrix.getElements()[i];

    if ($target.attr('id') === element.id ||
      util.getPageId($target) !== element.page) {
      continue;
    }

    if ((Math.abs(element.top - top) < buffer || Math.abs(element.bottom - top) < buffer)
      || (Math.abs(element.top - bottom) < buffer || Math.abs(element.bottom - bottom) < buffer)
      || (Math.abs(element.left - left) < buffer || Math.abs(element.right - left) < buffer)
      || (Math.abs(element.left - right) < buffer || Math.abs(element.right - right) < buffer)
      || (Math.abs(element.vmid - vmid) < buffer || Math.abs(element.hmid - hmid) < buffer)) {
      candidates.push(element);
    }
  }

  const $page = $target.parents('.page');
  const pageHmid = $page.width() / 2;
  const pageVmid = $page.height() / 2;

  removeSnapGuides();

  if (Math.abs(top) < pageBuffer) {
    addPageSnapGuide($page, 'top');
  } else if (Math.abs($page.height() - bottom) < pageBuffer) {
    addPageSnapGuide($page, 'bottom');
  }

  if (Math.abs(left) < pageBuffer) {
    addPageSnapGuide($page, 'left');
  } else if (Math.abs($page.width() - right) < pageBuffer) {
    addPageSnapGuide($page, 'right');
  }

  if (Math.abs(pageVmid - top) < pageBuffer) {
    addPageSnapGuide($page, 'vmid');
  } else if (Math.abs(pageVmid - bottom) < pageBuffer) {
    addPageSnapGuide($page, 'vmid');
  }

  if (Math.abs(pageHmid - left) < pageBuffer) {
    addPageSnapGuide($page, 'hmid');
  } else if (Math.abs(pageHmid - right) < pageBuffer) {
    addPageSnapGuide($page, 'hmid');
  }

  if (Math.abs(pageVmid - vmid) < pageBuffer) {
    addPageSnapGuide($page, 'vmid');
  }

  if (Math.abs(pageHmid - hmid) < pageBuffer) {
    addPageSnapGuide($page, 'hmid');
  }

  candidates.forEach((candidate) => {
    if (candidate && candidate.active) {

      if (Math.abs(candidate.top - top) < buffer) {
        addSnapGuide($target, 'top', 'snap-guide');
      } else if (Math.abs(candidate.bottom - top) < buffer) {
        addSnapGuide($target, 'top', 'snap-guide');
      }

      if (Math.abs(candidate.left - left) < buffer) {
        addSnapGuide($target, 'left', 'snap-guide');
      } else if (Math.abs(candidate.right - left) < buffer) {
        addSnapGuide($target, 'left', 'snap-guide');
      }

      if (Math.abs(candidate.top - bottom) < buffer) {
        addSnapGuide($target, 'bottom', 'snap-guide');
      } else if (Math.abs(candidate.bottom - bottom) < buffer) {
        addSnapGuide($target, 'bottom', 'snap-guide');
      }

      if (Math.abs(candidate.left - right) < buffer) {
        addSnapGuide($target, 'right', 'snap-guide');
      } else if (Math.abs(candidate.right - right) < buffer) {
        addSnapGuide($target, 'right', 'snap-guide');
      }

      if (Math.abs(candidate.vmid - vmid) < buffer) {
        addSnapGuide($target, 'vmid', 'snap-guide');
      }
      if (Math.abs(candidate.hmid - hmid) < buffer) {
        addSnapGuide($target, 'hmid', 'snap-guide');
      }
    }
  });
}

export function showResizeSnapGuides($target, event, top, left, edge) {
  let width = parseFloat($target.attr('data-width')) || 0;
  let height = parseFloat($target.attr('data-height')) || 0;
  let snapped = false;

  if (width === 0) {
    width = $target.width();
    height = $target.height();
    $target.attr('data-width', width);
    $target.attr('data-height', height);
  }

  const zoom = store.getState().zoom / 100;
  const newWidth = event.rect.width / zoom;
  const newHeight = event.rect.height / zoom;

  const right = left + newWidth;
  const bottom = top + newHeight;
  const $page = $target.parents('.page');
  const buffer = 3;
  const { length } = Matrix.getElements();
  let candidates = [];
  let i;
  for (i = 0; i < length; i++) {
    const element = Matrix.getElements()[i];
    if ($target.attr('id') !== element.id && util.getPageId($target) === element.page) {
        candidates.push(element);
    }
  }

  removeResizeSnapGuides();

  if (edge === 'top' && Math.abs(top) < buffer) {
    if(Math.abs(top) < 1) {
      $target.css('top', `0px`);
      $target.attr('data-y', 0);
    }
    addPageSnapGuide($page, 'top');
  }
  if (edge === 'bottom' && Math.abs($page.height() - bottom) < buffer) {
    $target.css('height', `${newHeight + Math.abs($page.height() - bottom)}px`);
    $target.attr('data-height', newHeight + Math.abs($page.height() - bottom));
    addPageSnapGuide($page, 'bottom');
  }
  if (edge === 'left' && Math.abs(left) < buffer) {
    if(Math.abs(left) < 1) {
      $target.css('left', `0px`);
      $target.attr('data-x', 0);
      // $target.css('width', `${newWidth - left}px`);
      // $target.attr('data-width', newWidth - left);
    }
    addPageSnapGuide($page, 'left');
  }
  if (edge === 'right' && Math.abs($page.width() - right) < buffer) {
    $target.css('width', `${newWidth +  Math.abs($page.width() - right)}px`);
    $target.attr('data-width', newWidth + Math.abs($page.width() - right));
    addPageSnapGuide($page, 'right');
  }
  candidates.forEach((candidate) => {
    if (candidate && candidate.active) {
    
      const $targetCandidate =  $(`#${candidate.id}`);
      const editLeft = typeof candidate.left === 'string' ? util.percentToPixel(parseFloat(candidate.left.split('%')[0]), util.getActiveDimensions().width) : candidate.left;
      const editTop = typeof candidate.top === 'string' ? util.percentToPixel(parseFloat(candidate.top.split('%')[0]), util.getActiveDimensions().height) : candidate.top;
      const editRight = editLeft + candidate.width;
      const editBottom = editTop + candidate.height;

      if(edge === 'left') {
        if (Math.abs(editLeft - left) < buffer) {
          if(Math.abs(editLeft - left) < 1) {
            $target.css('left', `${editLeft}px`);
            $target.attr('data-x', editLeft);
            $target.css('width', `${newWidth + (editLeft - left)/zoom}px`);
            $target.attr('data-width', newWidth +(editLeft - left)/zoom);

            snapped = true;
          }
          addSnapGuide($targetCandidate, 'left', 'resize-snap-guide');
        } else if (Math.abs(editRight - left) < buffer) {
          if(Math.abs(editRight - left) < 1) {
            $target.css('left', `${editRight}px`);
            $target.attr('data-x', editRight);
            $target.css('width', `${newWidth + (editRight - left)/zoom}px`);
            $target.attr('data-width', newWidth + (editRight - left)/zoom);
            snapped = true;
          }
          addSnapGuide($targetCandidate, 'right', 'resize-snap-guide');
        }
      } else if(edge === 'right') {
        if (Math.abs(editLeft - right) < buffer) {
          $target.css('width', `${newWidth + (editLeft - right)}px`);
          $target.attr('data-width', newWidth + (editLeft - right));
          addSnapGuide($targetCandidate, 'left', 'resize-snap-guide');
        } else if ( Math.abs(editRight - right) < buffer) {
          $target.css('width', `${newWidth + (editRight - right)}px`);
          $target.attr('data-width', newWidth + (editRight - right));
          addSnapGuide($targetCandidate, 'right', 'resize-snap-guide');
        }
      } else if (edge === 'top') {
        if (Math.abs(editTop - top) < buffer) {
          if(Math.abs(editTop - top) < 1) {
            $target.css('top', `${editTop}px`);
            $target.attr('data-y', editTop);
            $target.css('height', `${newHeight + (editTop - top)}px`);
            $target.attr('data-height', newHeight + (editTop - top));
            snapped = true;
          }
          addSnapGuide($targetCandidate, 'top', 'resize-snap-guide');
        } else if (Math.abs(editBottom - top) < buffer) {
          if(Math.abs(editBottom - top) < 1) {
            $target.css('top', `${editBottom}px`);
            $target.attr('data-y', editBottom);
            $target.css('height', `${newHeight + (editBottom - top)}px`);
            $target.attr('data-height', newHeight + (editBottom - top));
            snapped = true;
          }
          addSnapGuide($targetCandidate, 'bottom', 'resize-snap-guide');
        }
      } else {
        if (Math.abs(editTop - bottom) < buffer) {
          $target.css('height', `${newHeight + (editTop - bottom)}px`);
          $target.attr('data-height', newHeight + (editTop - bottom));
          addSnapGuide($targetCandidate, 'top', 'resize-snap-guide');
        } else if (Math.abs(editBottom - bottom) < buffer) {
          $target.css('height', `${newHeight + (editBottom - bottom)}px`);
          $target.attr('data-height', newHeight + (editBottom - bottom));
          addSnapGuide($targetCandidate, 'bottom', 'resize-snap-guide');
        }
      }
    }
  });
  return snapped;
}
